// src/components/TopBanner.jsx
import React from "react";

const TopBanner = () => {
  return (
    <>
      <style>{`
        .banner-center-label {
          flex: 1;
          text-align: center;
          z-index: 1;
          min-width: 0;
          overflow: hidden;
        }
        .banner-center-text {
          font-size: 20px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.55);
          font-weight: 500;
          white-space: nowrap;
        }
        @media (max-width: 768px) {
          .banner-center-text {
            font-size: 11px !important;
            letter-spacing: 1px !important;
            white-space: normal !important;
            line-height: 1.3 !important;
            color: rgba(255,255,255,0.6) !important;
          }
        }
      `}</style>

      <header
        style={{
          background: "linear-gradient(135deg, #0d1f2d 0%, #112233 50%, #0a1a28 100%)",
          borderBottom: "1px solid rgba(64, 190, 180, 0.25)",
          boxShadow: "0 4px 30px rgba(0,0,0,0.4)",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "14px 16px",
          gap: "8px",
        }}
      >
        {/* Background radial glows */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: `
              radial-gradient(ellipse at 15% 50%, rgba(64,190,180,0.08) 0%, transparent 55%),
              radial-gradient(ellipse at 85% 50%, rgba(255,200,80,0.06) 0%, transparent 50%)
            `,
            pointerEvents: "none",
          }}
        />

        {/* Bottom gradient line */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "1px",
            background:
              "linear-gradient(90deg, transparent, rgba(64,190,180,0.4), rgba(255,200,80,0.3), transparent)",
          }}
        />

        {/* LEFT LOGO (Advitiya) */}
        <div
          style={{
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            background: "rgba(64,190,180,0.07)",
            border: "1px solid rgba(64,190,180,0.18)",
            padding: "8px 16px",
            borderRadius: "12px",
            backdropFilter: "blur(8px)",
            flexShrink: 0,
          }}
        >
          <img
            src="/advitiya_trans1.png"
            alt="Advitiya Logo"
            style={{
              height: "64px",
              objectFit: "contain",
              filter:
                "brightness(1.8) contrast(1.1) drop-shadow(0 0 8px rgba(64,190,180,0.35))",
            }}
          />
        </div>

        {/* CENTER LABEL — always visible, shrinks on mobile */}
        <div className="banner-center-label">
          <span className="banner-center-text">
            Video KYC System
          </span>
        </div>

        {/* RIGHT LOGO (Kannit) */}
        <div
          style={{
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            background: "rgba(255,200,80,0.07)",
            border: "1px solid rgba(255,200,80,0.18)",
            padding: "8px 16px",
            borderRadius: "12px",
            backdropFilter: "blur(8px)",
            flexShrink: 0,
          }}
        >
          <img
            src="/kannit_logo1.png"
            alt="Kannit Logo"
            style={{
              height: "64px",
              objectFit: "contain",
              filter:
                "brightness(1.8) contrast(1.1) drop-shadow(0 0 8px rgba(255,200,80,0.35))",
            }}
          />
        </div>
      </header>
    </>
  );
};

export default TopBanner;